// <img> that serves right-sized WebP variants via srcset.
//
// scripts/make_responsive_images.py writes `<name>.w640.webp`,
// `<name>.w960.webp` and `<name>.w1280.webp` next to every image under /projects and /images, and the
// backend media upload does the same for /media/images. Phones then download
// ~50 KB instead of 500 KB–1.3 MB originals (the main cause of 9–14 s mobile
// LCP before this). If a variant is ever missing, onError drops srcset and the
// browser falls back to the original `src`, so an image never breaks.
//
// `priority` = the page's LCP image: eager + fetchpriority="high".

const VARIANT_RE = /^\/(projects|images|media\/images)\/.+\.(webp|jpe?g|png)$/i;

export const srcSetFor = (src) => {
    if (!src || !VARIANT_RE.test(src)) return undefined;
    // Folder names contain spaces/parentheses — encode, or srcset parsing
    // splits the URL apart.
    const base = encodeURI(src.replace(/\.[^.]+$/, ""));
    return `${base}.w640.webp 640w, ${base}.w960.webp 960w, ${base}.w1280.webp 1280w`;
};

const ResponsiveImg = ({
    src,
    sizes = "100vw",
    priority = false,
    loading,
    alt = "",
    ...rest
}) => {
    const srcSet = srcSetFor(src);
    return (
        <img
            src={src}
            srcSet={srcSet}
            sizes={srcSet ? sizes : undefined}
            alt={alt}
            loading={priority ? "eager" : loading || "lazy"}
            fetchPriority={priority ? "high" : undefined}
            decoding={priority ? "sync" : "async"}
            onError={(e) => {
                const img = e.currentTarget;
                if (img.getAttribute("srcset")) {
                    img.removeAttribute("srcset");
                    img.removeAttribute("sizes");
                }
            }}
            {...rest}
        />
    );
};

export default ResponsiveImg;
